export function RecentJournalPlaceholder() {
  return (
    <section
      data-testid="placeholder-recent-journal"
      className="rounded-2xl p-4 opacity-70"
      style={{
        background: "#FFFFFF",
        border: "1px solid #EAE4DA",
        minHeight: "80px",
      }}
    >
      <h3
        className="font-display text-lg italic"
        style={{ color: "#8A4E9C" }}
      >
        Recent Journal
      </h3>
      <p className="mt-1 text-xs" style={{ color: "#9A8A78" }}>
        Coming in Week 2.4
      </p>
    </section>
  );
}
